// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LxnF","content":"styles_content__no9lr"};